import ComponentWithSocket from '../../lib/component';
import { Component } from 'vue-property-decorator';

import template from './account.vue';

import * as Store from './../../store';

import PhoneInput from '../../components/phone-input/index';
import { PhoneValidation, PhoneValue } from '../../utils/phone-validation';

interface AccountData {
    editAccountInfo: boolean;
    editName: boolean;
    theLots: any;
    theUser: any;
    verification?: any;
    activeList: string;
    // Telefonul editat separat: prefix + numar (conturile vechi sunt convertite la afisare)
    phone: PhoneValue;
    // Valoarea de la incarcare, ca sa stim daca userul a modificat telefonul
    initialPhone: PhoneValue;
}

@Component({
    mixins: [template],
    components: {
        PhoneInput,
    },
})
export default class UserAccount extends ComponentWithSocket {
    data: AccountData = {
        editAccountInfo: false,
        editName: false,
        theLots: {},
        theUser: {},
        verification: undefined,
        activeList: 'won',
        phone: PhoneValidation.defaultValue(),
        initialPhone: PhoneValidation.defaultValue(),
    };

    constructor() {
        super();

        // Starea modificata din callback-uri sta in `data`: constructorul nu ruleaza pe componenta reala
        this.wsListener.onGet('auth.profile', (success: boolean, data: any) => {
            if (success) {
                this.data.theUser = data.profile;
                this.data.phone = PhoneValidation.fromUser(data.profile);
                this.data.initialPhone = { ...this.data.phone };
                this.data.verification = data.verification;
                Store.commitLoaderVisibility(this.$store, false);
            } else {
            }
        });

        // Erorile de validare de la salvare (ex: telefon invalid pentru tara aleasa)
        this.wsListener.onPost('auth.profile', (success: boolean, data: any) => {
            if (!success) {
                alert(data);

                // Formularul s-a inchis deja; reincarcam ce e salvat ca sa nu para modificat
                this.wsListener.sendGet('auth.profile');
            }
        });

        this.wsListener.onGet('auth.lots', (success: boolean, data: any) => {
            this.data.theLots = data;
        });
    }

    beforeRouteLeave(to: any, from: any, next: any) {
        this._beforeLeave(to, from);
        next();
    }

    mounted() {
        this.wsListener.sendGet('auth.profile');
        this.wsListener.sendGet('auth.lots', { won: true });
    }

    getWonList() {
        this.data.activeList = 'won';
        this.wsListener.sendGet('auth.lots', { won: true });
    }

    getBiddedList() {
        this.data.activeList = 'bidded';
        this.wsListener.sendGet('auth.lots', { bidded: true });
    }

    getLikedList() {
        this.data.activeList = 'liked';
        this.wsListener.sendGet('auth.lots', { liked: true });
    }

    uploadNewAvatar() {
        let input: any = document.getElementById('new-profile-pic'),
            $this: any = this;

        if (input.files && input.files[0]) {
            let FR = new FileReader();

            FR.addEventListener('load', (e: any) => {
                $this.data.theUser.avatarUrl = e.target.result;
            });

            FR.readAsDataURL(input.files[0]);
        }
    }

    // Numarul vechi (fara prefix) ramane neatins pana cand userul il modifica
    get sendPrefixedPhone(): boolean {
        const phone = this.data.phone;
        const initial = this.data.initialPhone;

        return (
            !!this.data.theUser.prefix ||
            phone.prefix !== initial.prefix ||
            phone.phoneCountry !== initial.phoneCountry ||
            PhoneValidation.digits(phone.phone) !==
                PhoneValidation.digits(initial.phone)
        );
    }

    // Userul a ales alt numar decat cel salvat
    get phoneChanged(): boolean {
        const phone = this.data.phone;
        const initial = this.data.initialPhone;

        return (
            phone.prefix !== initial.prefix ||
            phone.phoneCountry !== initial.phoneCountry ||
            PhoneValidation.digits(phone.phone) !==
                PhoneValidation.digits(initial.phone)
        );
    }

    doSaveSettings() {
        const sendPrefixed = this.sendPrefixedPhone;
        const phoneChanged = this.phoneChanged;

        if (sendPrefixed) {
            const phoneError = PhoneValidation.validate(this.data.phone);
            if (phoneError) {
                return alert(phoneError);
            }
        }

        this.data.editName = false;
        this.data.editAccountInfo = false;

        let $this = this;

        // Numarul nou se salveaza abia dupa confirmarea prin SMS (/verify-phone);
        // pana atunci restul datelor pleaca cu numarul salvat, neschimbat
        const phonePayload = phoneChanged
            ? $this.data.theUser.prefix
                ? PhoneValidation.toPayload($this.data.initialPhone)
                : { phone: $this.data.theUser.phone }
            : sendPrefixed
            ? PhoneValidation.toPayload($this.data.phone)
            : { phone: $this.data.theUser.phone };

        this.wsListener.sendPost('auth.profile', {
            firstName: $this.data.theUser.firstName,
            lastName: $this.data.theUser.lastName,
            email: $this.data.theUser.email,
            ...phonePayload,
            avatar: $this.data.theUser.avatarUrl,
        });

        if (phoneChanged) {
            const newPhone = PhoneValidation.toPayload($this.data.phone);

            this.goToRoute(
                '/verify-phone?mode=change' +
                    '&prefix=' + encodeURIComponent(newPhone.prefix) +
                    '&phone=' + encodeURIComponent(newPhone.phone) +
                    '&phoneCountry=' + encodeURIComponent(newPhone.phoneCountry),
            );
        }
    }

    doEditName() {
        this.data.editName = !this.data.editName;
    }

    goToRoute(theRoute: string) {
        if (this.$root.$options && this.$root.$options.router) {
            this.$root.$options.router.push(theRoute);
        }
    }

    doLogout() {
        Store.commitLoggedInState(this.$store, false);
        Store.commitLoggedInUser(this.$store, {});

        this.wsListener.setAuthState(false);

        this.wsListener.reconnect(() => {
            this.goToRoute('/login');
        });
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/views/account/index.ts